import { lazy, Suspense } from "react";
import useActiveBannerId from "./hooks/useActiveBannerId";
import { Banner } from "./Banners.config";
import type { BannerId } from "./Banners.config";

const BANNER_COMPONENTS: Record<BannerId, React.LazyExoticComponent<React.ComponentType>> = {
  [Banner.RemoteAnnouncementBanner]: lazy(() => import("components/Banners/RemoteAnnouncementBanner")),
  [Banner.SubscriptionPastDueBanner]: lazy(() => import("components/Banners/PaymentOverdueBanner")),
  [Banner.SubscriptionUpcomingRenewalBanner]: lazy(() => import("components/Banners/UpcomingRenewalBanner")),
  [Banner.SubscriptionTrialBanner]: lazy(() => import("components/Banners/TrialBanner")),
  [Banner.LaunchBanner]: lazy(() => import("components/Banners/LaunchBanner")),
  [Banner.HyroxConditioningTestBanner]: lazy(() => import("components/Banners/HyroxConditioningTestBanner")),
  [Banner.HyroxOutputTiersBanner]: lazy(() => import("components/Banners/HyroxOutputTiersBanner")),
};

/** @link https://app.notion.com/p/output-sports/In-Product-Banners-3c30c9b3fff4809380fbd1fc804bed36 */
function Banners() {
  const activeBannerId = useActiveBannerId();

  if (!activeBannerId) return null;
  const ActiveBanner = BANNER_COMPONENTS[activeBannerId];

  return (
    <Suspense fallback={null}>
      <ActiveBanner />
    </Suspense>
  );
}

export default Banners;
